// Standaardvariant (snippets/variant-main-picker.liquid): kiest bij binnenkomst de
// ingestelde variant, alsof de bezoeker die zelf koos. Horizon's variant-picker doet
// daarna de rest (prijs, foto's, URL). Alleen dropdowns en knoppen/rondjes.
const picker = document.querySelector('variant-picker[data-rf-default-options]');

if (picker && !picker.dataset.rfDefaultApplied) {
  picker.dataset.rfDefaultApplied = 'true';
  const wanted = JSON.parse(picker.dataset.rfDefaultOptions || '[]');
  let last = null;

  picker.querySelectorAll('select').forEach((select, index) => {
    const option = Array.from(select.options).find((o) => o.value === wanted[index]);
    if (!option || option.selected) return;
    Array.from(select.options).forEach((o) => o.removeAttribute('selected'));
    option.setAttribute('selected', 'selected');
    select.value = option.value;
    last = select;
  });

  picker.querySelectorAll('fieldset').forEach((fieldset, index) => {
    const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((i) => i.value === wanted[index]);
    if (!input || input.checked) return;
    input.checked = true;
    last = input;
  });

  if (last) {
    // Horizon zet ?variant= in de URL op basis van het laatst gewijzigde veld; geef dat
    // het juiste variant-ID mee, anders klopt de link niet bij delen of herladen.
    const target = last instanceof HTMLSelectElement ? last.options[last.selectedIndex] : last;
    target.dataset.variantId = picker.dataset.rfDefaultId;
    customElements.whenDefined('variant-picker').then(() => {
      last.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}
